import classNames from 'classnames';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import ProductReviewsItem from './ProductReviewsItem';

const ProductReviewsModal = ({ reviews, toggleHandler, typeAttribute, defaultReview }) => {
  const [images, setImages] = useState([]);
  const [selectedReview, setSelectedReview] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [step, setStep] = useState(1);

  const modal = useRef(null);

  useEffect(() => {
    const imagesArr = [];
    for (const review of reviews) {
      if (review.images.length > 0) {
        for (const image of review.images) {
          imagesArr.push({ id: review.id, url: image.sizes.medium });
        }
      }
    }

    setImages(imagesArr);
  }, [reviews]);

  useEffect(() => {
    if (defaultReview.review) {
      setStep(2);
      setSelectedReview(defaultReview.review);
      setSelectedImage(defaultReview.image);
    }
  }, [defaultReview]);

  const closeModal = useCallback(() => {
    modal.current.classList.add('product-reviews-modal--hiding');

    setTimeout(() => {
      modal.current.classList.remove('product-reviews-modal--hiding');
      toggleHandler();
    }, 1000);
  }, [modal]);

  const stepHandler = useCallback(
    ({ id, url }) =>
      () => {
        const review = reviews.find((i) => i.id === id);
        setSelectedReview(review);
        setSelectedImage(url);
        setStep(2);
      },
    [reviews]
  );

  const sliderChangeHandler = useCallback(
    (isNext = false) => {
      const lastIndex = reviews.length - 1;

      const currentIndex = reviews.findIndex((i) => i.id === selectedReview.id);
      if (
        (currentIndex === 0 && isNext) ||
        (currentIndex === lastIndex && !isNext) ||
        (currentIndex > 0 && currentIndex < lastIndex)
      ) {
        const nextReview = reviews[isNext ? currentIndex + 1 : currentIndex - 1];
        setSelectedReview(nextReview);
        setSelectedImage(nextReview.images[0]);
      }
    },
    [reviews, selectedReview]
  );

  return (
    <div className='product-reviews-modal' ref={modal} onClick={closeModal}>
      <div className='product-reviews-modal__dialog' onClick={(e) => e.stopPropagation()}>
        <span className='product-reviews-modal__close' onClick={closeModal}>
          &times;
        </span>
        <div className='product-reviews-modal__header'>
          {step === 1 && <p>{typeAttribute} Customer Images</p>}
        </div>

        <div className={classNames('product-reviews-modal__body', { 'is-step-1': step === 1 })}>
          <ul
            className={classNames(
              'product-reviews-modal__images product-reviews-modal__step product-reviews-modal__step--1',
              {
                'product-reviews-modal__step--1-active': step === 1,
              }
            )}>
            {images &&
              images.map((image, i) => (
                <li key={i}>
                  <img onClick={stepHandler(image)} src={image.url} className='img-fluid p-2' />
                </li>
              ))}
          </ul>

          <div
            className={classNames(
              'product-reviews-modal__review-item product-reviews-modal__step product-reviews-modal__step--2',
              {
                'product-reviews-modal__step--2-active': step === 2,
              }
            )}>
            <div className='row'>
              <div className='col-12'>
                <span className='product-reviews-modal__back-to-customers' onClick={() => setStep(1)}>
                  Back to customer reviews
                </span>
              </div>
            </div>

            {selectedReview && (
              <React.Fragment>
                <button
                  type='button'
                  onClick={() => sliderChangeHandler(false)}
                  className='slick-arrow slick-prev slick-disabled'>
                  Previous
                </button>
                <div key={selectedReview.id} className='product-reviews-modal__slider-item row'>
                  <div className='col-md-6'>
                    <img className='img-fluid d-block mx-auto mx-md-0' src={selectedImage} />
                    <ul className='product-reviews-modal__slider-images'>
                      {selectedReview.images.map((image, i) => (
                        <li key={i}>
                          <img
                            className={classNames('img-fluid', {
                              'product-reviews-modal__slider-images--active': selectedImage.url === image.url,
                            })}
                            src={image.url}
                            onClick={() => setSelectedImage(image)}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className='col-md-6'>
                    {selectedReview && <ProductReviewsItem review={selectedReview} />}
                  </div>
                </div>
                <button
                  type='button'
                  onClick={() => sliderChangeHandler(true)}
                  className='slick-arrow slick-next slick-disabled'>
                  Next
                </button>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductReviewsModal;
